import React, { useEffect, useState } from "react";

const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
const months = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];

function fmt2(n) { return String(n).padStart(2, "0"); }

export default function LiveClock({ className = "" }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const dateStr = `${days[now.getDay()]}, ${now.getDate()} ${months[now.getMonth()]} ${now.getFullYear()}`;
  const timeStr = `${fmt2(now.getHours())}:${fmt2(now.getMinutes())}:${fmt2(now.getSeconds())}`;

  return (
    <div className={`flex items-baseline gap-2 ${className}`} data-testid="live-clock">
      <span className="text-[0.72rem] font-semibold text-[hsl(var(--muted-foreground))] whitespace-nowrap">{dateStr}</span>
      <span className="text-sm sm:text-base font-extrabold text-[#0e2b26] tabular-nums whitespace-nowrap tracking-tight">{timeStr}</span>
    </div>
  );
}
